import { DocumentSharePickerActionTypes } from './action_types'
import { DocumentSharePickerMutationTypes } from './mutation_types'

export const actions: StoreActions<DocumentSharePickerActionTypes, DocumentSharePickerMutationTypes> = {
  [DocumentSharePickerActionTypes.DISABLE_GROUPS]({ commit }, members: Member[]) {
    commit(DocumentSharePickerMutationTypes.ADD_GROUPS_TO_DISABLED, members)
  },
  [DocumentSharePickerActionTypes.DISABLE_MEMBERS]({ commit }, members: Member[]) {
    commit(DocumentSharePickerMutationTypes.ADD_MEMBERS_TO_DISABLED, members)
  },
  [DocumentSharePickerActionTypes.RESET_DISABLED_GROUPS]({ commit }) {
    commit(DocumentSharePickerMutationTypes.SET_DISABLED_GROUPS, [])
  },
  [DocumentSharePickerActionTypes.RESET_DISABLED_MEMBERS]({ commit }) {
    commit(DocumentSharePickerMutationTypes.SET_DISABLED_MEMBERS, [])
  },
  [DocumentSharePickerActionTypes.SELECT_GROUP]({ commit },  group: Group) {
    commit(DocumentSharePickerMutationTypes.ADD_GROUP_TO_SELECTED, group)
    commit(DocumentSharePickerMutationTypes.REMOVE_MEMBERS_FROM_SELECTED, group.members)
  },
  [DocumentSharePickerActionTypes.UNSELECT_GROUP]({ commit }, group: Group) {
    commit(DocumentSharePickerMutationTypes.REMOVE_GROUP_FROM_SELECTED, group)
  },
  [DocumentSharePickerActionTypes.INIT_SELECTED_GROUPS]({ commit }, groups: Group[]) {
    commit(DocumentSharePickerMutationTypes.SET_SELECTED_GROUPS, groups)
  },
  [DocumentSharePickerActionTypes.UNSELECT_MEMBER]({ commit }, member: Member) {
    commit(DocumentSharePickerMutationTypes.REMOVE_MEMBERS_FROM_SELECTED, [member])
  },
  [DocumentSharePickerActionTypes.INIT_SELECTED_MEMBERS]({ commit }, members: Member[]) {
    commit(DocumentSharePickerMutationTypes.SET_SELECTED_MEMBERS, members)
  },
  [DocumentSharePickerActionTypes.RESET_DISABLED_GROUPS_AND_MEMBERS]({ commit }) {
    commit(DocumentSharePickerMutationTypes.SET_DISABLED_GROUPS, [])
    commit(DocumentSharePickerMutationTypes.SET_DISABLED_MEMBERS, [])
  },
  [DocumentSharePickerActionTypes.RESET_SELECTED_GROUPS_AND_MEMBERS]({ commit }) {
    commit(DocumentSharePickerMutationTypes.SET_SELECTED_GROUPS, [])
    commit(DocumentSharePickerMutationTypes.SET_SELECTED_MEMBERS, [])
    commit(DocumentSharePickerMutationTypes.SET_HIGHLIGHTED_MEMBER, null)
  },
  [DocumentSharePickerActionTypes.HIGHLIGHT_MEMBER]({ commit }, member: Member) {
    // When selected from the search field, member should be highlighted for 3s
    const HIGHLIGHT_DURATION = 3000

    commit(DocumentSharePickerMutationTypes.SET_HIGHLIGHTED_MEMBER, member)

    setTimeout(() => {
      commit(DocumentSharePickerMutationTypes.SET_HIGHLIGHTED_MEMBER, null)
    }, HIGHLIGHT_DURATION)
  },
}